/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardian_Child_Unset_TeenInputs */

const fr_guardian_child_unset_teen = /** @type {(inputs: Guardian_Child_Unset_TeenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirer le statut ado`)
};

/**

* @param {Guardian_Child_Unset_TeenInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const guardian_child_unset_teen = /** @type {((inputs?: Guardian_Child_Unset_TeenInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardian_Child_Unset_TeenInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_guardian_child_unset_teen(inputs)
});